// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tilC","rootMobile":"styles_rootMobile__2nqnU"};